<template>
  <div class="course">
    <Banner page="course"/>
    <!-- 课程列表 -->
    <ActivityGoodsList :status="2">
      <div slot="title">
        <a-icon type="fire" theme="twoTone" />
        <h3 class="title">推荐课程</h3>
      </div>
    </ActivityGoodsList>

    <ActivityGoodsList :type="0">
      <div slot="title">
        <a-icon type="calculator" theme="twoTone" />
        <h3 class="title">入门课程</h3>
      </div>
    </ActivityGoodsList>

    <ActivityGoodsList :type="1">
      <div slot="title">
        <a-icon type="rocket" theme="twoTone" />
        <h3 class="title">进阶课程</h3>
      </div>
    </ActivityGoodsList>
    <!-- TODO 单页课程 -->
  </div>
</template>

<script>
import Banner from "../../components/Banner";
import ActivityGoodsList from "@/components/course/ActivityGoodsList";

export default {
  name: "CourseGoods",
  components: {
    Banner,
    ActivityGoodsList
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style land="less" scoped>
</style>